import './App.css';
import { useEffect, useState } from 'react';
import { getJobs } from './api';
import JobTable from './JobTable';



function App() {
  var [jobs, setJobs] = useState([])
  useEffect(() => {
    async function init() {
      var _ = await getJobs()
      var jobs = _["jobs"]
      setJobs(jobs)
    }
    init()

  }, [])

  return (
    <div className="App">
      <JobTable jobs={jobs} />
    </div>
  );
}

export default App;
